module.exports = __webpack_public_path__ + "static/zene2-ae882cd6044641903494029be49b5b7d.oga";